import ReportCard from '../../../components/reportCard/ReportCard';
import usePageView from '../../../hooks/analytics/usePageView';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import verifyToken from '../../../utils/tokenUtils';
import { config } from '../../../config/Constants';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Axios from 'axios';
import './formsLanding.css';

const FormsLanding = () => {
  usePageView();

  const navigate = useNavigate();
  const [forms, setforms] = useState([{}]);
  const getCustomer = async() => { return Cookies.get('cp-cn'); };
  const getAuthToken = () => { return Cookies.get('gtms-cp-auth'); };

  useEffect(() => {
    const token = getAuthToken();
    token ? verifyToken(token) : navigate('/');
    getReports();
  }, []);

  const getReports = async () => {
    const customer = await getCustomer()
    const response = await Axios.get(config.url.GET_FORMS, {
      params: { companyName: customer, }
    });
    setforms(response.data.forms);
  }

  const handleClick = async (id, form_name) => { 
    if (form_name == 'Submit Parcel Claims') {
      window.open("https://gtms.clickup.com/forms/37415501/f/13nujd-16313/ZXZPBWJW6443WW77V5", "_blank");
    } else if (form_name == 'Submit Freight Claims') {
      window.open("https://gtms.clickup.com/forms/37415501/f/13nujd-18293/ZH5BR89TULHPV7E8G9", "_blank");
    } else {
      navigate(`/forms/${id}`);
    } 
  };

  return (
    <div className='LandingPage'>
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="FormLandingPageContent">
          {forms.map(forms =>
            <ReportCard
              key={forms.ID}
              title={forms.FORM_NAME}
              description={forms.FORM_DESCRIPTION}
              onClick={() => handleClick(forms.ID, forms.FORM_NAME)}
              />
            )}
        </div>
      </div>
    </div>
  )
}

export default FormsLanding